/**
 * NavBar — Top navigation bar.
 * Layout: [NEP Logo | Home | User Admin] ... [Theme Toggle | User Dropdown (Profile, Change Password, Logout)]
 */

import { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useTheme } from "../contexts/ThemeContext";

export default function NavBar() {
  const { user, isAdmin, logout } = useAuth();
  const { darkMode, toggleDarkMode } = useTheme();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleLogout = async () => {
    setDropdownOpen(false);
    await logout();
    navigate("/login");
  };

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const displayName =
    [user?.firstName, user?.lastName].filter(Boolean).join(" ") || user?.email || "";

  return (
    <nav className="portal-nav">
      <div className="portal-nav-left">
        <Link to="/" className="portal-nav-brand">
          <img
            src="/nep-logo.png"
            alt="NEP"
            className="portal-nav-logo"
          />
        </Link>
        <Link to="/" className="portal-nav-link">
          Home
        </Link>
        {isAdmin && (
          <Link to="/admin/users" className="portal-nav-link">
            User Admin
          </Link>
        )}
      </div>
      <div className="portal-nav-right">
        <button className="portal-nav-link portal-nav-theme" onClick={toggleDarkMode} title="Toggle dark mode">
          {darkMode ? "☀ Light" : "☾ Dark"}
        </button>
        {user && (
          <div className="portal-nav-dropdown" ref={dropdownRef}>
            <button
              className="portal-nav-user-btn"
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              {displayName}
              <span className="portal-nav-caret">▾</span>
            </button>
            {dropdownOpen && (
              <div className="portal-nav-dropdown-menu">
                <Link to="/profile" className="portal-nav-dropdown-item" onClick={() => setDropdownOpen(false)}>
                  Edit Profile
                </Link>
                {!user.email.endsWith("@nepgroup.com") && (
                  <Link to="/change-password" className="portal-nav-dropdown-item" onClick={() => setDropdownOpen(false)}>
                    Change Password
                  </Link>
                )}
                <button className="portal-nav-dropdown-item portal-nav-dropdown-logout" onClick={handleLogout}>
                  Logout
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </nav>
  );
}
